import { Box, Grid } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import ClientEditBusinessInfo from './ClientEditBusinessInfo';
import EditClientDownload from './EditClientDownload';
import EditClientIntroduction from './EditClientIntroduction';
import EditClientPreq from './EditClientPreq';



function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


export default function EditClient() {
  const [value, setValue] = React.useState(0);
  const params = new URLSearchParams(window.location.search);
  const Vendor = params.get("vendorid");
  const orgId = params.get("OrgId");


  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={2} md={1}>
        </Grid>
        <Grid item xs={12} md={10}>
          <Box >
            <span style={{ color: 'rgb(0,0,0)', marginLeft: "28px", fontSize: "28px", fontWeight: "600" }} >{orgId == "1" ? "Edit Admin" : "Edit Client"}</span>
            <Box sx={{ borderColor: 'divider' }}>
              <Tabs sx={{ marginLeft: 3 }} value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab label="Business Information" {...a11yProps(0)} />
                <Tab label="Downloads" {...a11yProps(1)} hidden={orgId == "1"} />
                <Tab label="Introduction Content" {...a11yProps(2)} hidden={orgId == "1"} />
                <Tab label="Prequalification Requirements" {...a11yProps(3)} hidden={orgId == "1"} />

              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <ClientEditBusinessInfo org={orgId} />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <EditClientDownload org={orgId} />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <EditClientIntroduction org={orgId} />
            </TabPanel>
            <TabPanel value={value} index={3}>
              <EditClientPreq org={orgId} />
            </TabPanel>

          </Box>
        </Grid>
        <Grid item xs={2} md={1}>

        </Grid>
      </Grid>


    </>
  )
}
